export class Controller extends HTMLElement {
    private updateVh: (type: 'resize' | 'orientationchange' | 'init') => void

    constructor() {
        super()

        // Create function to update CSS custom property for viewport height
        // @ts-ignore
        this.updateVh = (type: 'resize' | 'orientationchange' | 'init') => {
            // dynamic vh
            const dvh = window.innerHeight * 0.01 // this will update on resize
            document.documentElement.style.setProperty('--dvh', `${dvh}px`)

            // don't update vh on resize if window is less than 768px
            if (type === 'resize' && window.innerWidth < 768) {
                return
            }

            const vh = window.innerHeight * 0.01
            document.documentElement.style.setProperty('--vh', `${vh}px`)
        }
    }

    connectedCallback() {
        // Set initial viewport height
        this.updateVh('init')

        // Update on resize and orientation change
        window.addEventListener('resize', () => this.updateVh('resize'))
        window.addEventListener('orientationchange', () => this.updateVh('orientationchange'))
    }

    disconnectedCallback() {
        // Clean up event listeners
        window.removeEventListener('resize', () => this.updateVh('resize'))
        window.removeEventListener('orientationchange', () => this.updateVh('orientationchange'))
    }
}

// Register the web component
customElements.define('app-controller', Controller)
